/**
 * Synchronise le résumé de la barre collante avec la variante sélectionnée.
 *
 * Le prix et la miniature du résumé sont rendus côté serveur et vivent en dehors
 * de [data-ref="add-to-cart-button-container"], le seul noeud que product-form.js
 * re-rend au changement de variante. Sans ça, choisir un coloris plus cher
 * laisserait l'ancien prix affiché en bas d'écran.
 *
 * Note : sticky-add-to-cart.js n'est pas modifiable utilement — le thème charge
 * sa version minifiée (.s.min.js). D'où ce fichier séparé.
 */
(function () {
  'use strict';

  if (window.__zoemassStickySync) return;
  window.__zoemassStickySync = true;

  function format(el, cents) {
    var currency = el.dataset.currency || 'EUR';
    var locale = el.dataset.locale || 'fr';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function sync() {
    document.querySelectorAll('sticky-add-to-cart').forEach(function (bar) {
      var container = bar.querySelector('[data-ref="add-to-cart-button-container"]');
      var target = bar.querySelector('.zsum__price');
      if (!container || !target) return;

      // Le conteneur du bouton porte toujours data-price, même quand l'option
      // « afficher le prix dans le bouton » est désactivée.
      var cents = parseInt(container.dataset.price, 10);
      if (isNaN(cents)) return;

      var markup = format(target, cents);
      var compare = parseInt(container.dataset.compareAtPrice, 10);
      if (!isNaN(compare) && compare > cents) {
        markup += ' <s>' + format(target, compare) + '</s>';
      }

      target.innerHTML = markup;
    });
  }

  document.addEventListener('variant:updated', function () {
    // Laisse product-form.js remplacer le conteneur avant de lire son contenu.
    window.requestAnimationFrame(sync);
  });
})();
